<template>
  <div class="modal-container clearfix">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        title-width="140"
        :data="formData"
        :rules="formRules"
        @reset="reset"
    >
      <vxe-form-item span="24">
        <template>
          <div class="title">
            <div class="block"></div>
            <span>基本信息</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="订单类型" field="ordersType" span="8">
        <template>
          <Select v-model="formData.ordersType" @on-change="clearValidate">
            <Option v-for="(item, index) in orderType" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
        </template>
      </vxe-form-item>
      <vxe-form-item title="订单标题" field="ordersTitleAttached" span="8">
        <template v-slot="scope">
          <vxe-input class="rowInput" v-model="formData.ordersTitleAttached" placeholder="选填" clearable
                     @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="销售方" field="sellerName" span="8">
        <template>
          <div class="input-border">
            <a target="_black" @click="openChooseAccount()">
              {{ formData.sellerName ? formData.sellerName : "请选择销售方" }}
            </a>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="关联主订单" field="relOrdersNum" span="8">
        <template>
          <div class="input-border">
            <a @click="openOrderModal()" v-if="!isOrder">{{
                formData.relOrdersNum === null || formData.relOrdersNum === "" ? "选择关联主订单" : formData.relOrdersNum
              }}
              <Icon type="md-close" @click.stop="clearRelOrdersNum" v-show="formData.relOrdersNum"/>
            </a>
            <span v-else>{{ formData.relOrdersNum }}</span>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="所属公司" field="compName" span="8">
        <template>
          <div class="input-border" style="display: flex;align-items: center;">
            <platform-corp :row="formData" :isEdit="!formData.relOrdersNum || formData.relOrdersNum === ''"
                           :field="'compName'" :placeholder="'请选择所属公司'" @select="clearValidate"></platform-corp>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="业务员" field="saleMan" span="8">
        <template>
          <div class="input-border" style="display: flex;align-items: center;">
            <sales-man
                :isEdit="!formData.relOrdersNum || formData.relOrdersNum === ''"
                :row="formData"
                :field="'saleMan'"
                :placeholder="'请选择业务员'"
                @setSaleMan="setSaleMan"
                @focus="clearValidate"
                @blur="clearValidate"
            ></sales-man>
          </div>
        </template>
      </vxe-form-item>
      <vxe-form-item title="客户经理" field="clientManage" span="8">
        <template v-slot="scope">
          <vxe-input class="rowInput" v-model="formData.clientManage" placeholder="自动带入" readonly
                     @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="金额" field="settlementAmount" span="8">
        <template v-slot="scope">
          <vxe-input class="rowInput" v-model="formData.settlementAmount" type="number" placeholder="必填" clearable
                     @input="$refs.xForm.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="关联合同" field="relContractNum" span="8">
        <template>
          <div class="input-border">
            <a @click="openContract">{{
                formData.relContractNum === null || formData.relContractNum === '' ? '请选择关联合同' : formData.relContractNum
              }}
              <Icon type="md-close" @click.stop="clearContractNum" v-show="formData.relContractNum"/>
            </a>
          </div>
        </template>
      </vxe-form-item>
    </vxe-form>
    <upload-table ref="uploadTable" style="margin-top: 20px;margin-bottom: 50px;" :row="formData"
                  :initFileList="fileList"></upload-table>
    <div class="footer-btn" v-if="!isUpdate">
      <Button type="primary" style="border-radius: 5px;" @click="submitEvent()">创建</Button>
    </div>
    <div class="footer-btn" v-if="isUpdate">
      <Button style="border-radius: 5px;" @click="close">取消</Button>
      <Button type="primary" style="border-radius: 5px;margin-left: 5px" @click="submitEvent()">提交</Button>
    </div>
    <vxe-modal v-model="isShowChooseAccount" width="800" height="600" resize remember title="客户名称">
      <account @choose="chooseAccountEvent" ref="chooseAccount"></account>
    </vxe-modal>
    <vxe-modal v-model="isShowContract" title="关联合同" width="1400" height="600" resize>
      <choose-agreement @choose="chooseAgreement" ref="agreementModel" :isSalesMan="true"></choose-agreement>
    </vxe-modal>
    <vxe-modal v-model="isShowChooseOrderTwo" width="1300" height="700" resize remember title="选择订单">
      <choose-order-new @choose="chooseOrderEventTwo" :currentRow="formData"
                        ref="refPaymentAboutOrderNew"></choose-order-new>
    </vxe-modal>
  </div>
</template>
<script>
import SalesMan from "@/components/common/SalesMan";
import PlatformCorp from "@/components/common/PlatformCorp";
import ChooseAgreement from "@/components/order2.0/Agreement/ChooseAgreement";
import UploadTable from "@/components/modal/UploadTable";
import Account from '@/components/modal/Account';
import ChooseOrderNew from "@/components/modal/ChooseOrderNew";
import $api from "@/apiProvider";
import {showLoading, hideLoading} from "@/utils/util";

export default {
  components: {SalesMan, PlatformCorp, ChooseAgreement, UploadTable, Account, ChooseOrderNew},
  data() {
    return {
      formData: {
        id: null,
        relOrdersNum: '',
        relContractNum: '',
        fileList: []
      },
      formRules: {
        ordersType: [{required: true, message: "请选择订单类型"}],
        sellerName: [{required: true, message: "请选择销售方"}],
        compName: [{required: true, message: "请选择所属公司"}],
        saleMan: [{required: true, message: "请选择业务员"}],
        settlementAmount: [{required: true, message: "请输入金额"}],
      },
      orderType: [],
      isShowContract: false,
      isShowChooseAccount: false,
      isShowChooseOrderTwo: false,
      fileList: [],
      isUpdate: false,
      isOrder: false
    }
  },
  created() {
    this.getDict(59000, 'orderType');
  },
  methods: {
    initOrder(data) {
      this.isOrder = true;
      this.$set(this.formData, 'relOrdersNum', data.ordersNum);
      this.$set(this.formData, 'clientManage', data.clientManager);
      this.$set(this.formData, 'clientManageId', data.clientManagerId);
      this.$set(this.formData, 'saleMan', data.saleMan);
      this.$set(this.formData, 'saleManId', data.saleManId);
      this.$set(this.formData, 'compName', data.compName);
      this.$set(this.formData, 'platformCompanyId', data.platformCompanyId);
      this.$set(this.formData, 'ordersTitleAttached', data.ordersTitle);
    },
    close() {
      this.$emit('close');
    },
    setUpdate(data) {
      this.isUpdate = true;
      this.$set(this, 'formData', {
        id: data.id,
        ordersType: data.ordersType,
        ordersTitleAttached: data.ordersTitleAttached,
        sellerName: data.sellerName,
        sellerId: data.sellerId,
        compName: data.compName,
        platformCompanyId: data.platformCompanyId,
        saleMan: data.saleMan,
        saleManId: data.saleManId,
        sellerUserType: data.sellerUserType,
        settlementAmount: data.settlementAmount,
        fileList: data.files,
        fileUuidList: data.files,
        relOrdersNum: data.relOrdersNum,
        relOrdersId: data.relOrdersId,
        relContractNum: data.relContractNum,
        relContractId: data.relContractId,
        relContractType: data.relContractType,
        relContractCate: data.relContractCate,
        clientManage: data.clientManage,
        clientManageId: data.clientManageId,
      })
      this.$set(this, 'fileList', data.files);
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    setSaleMan(val) {
      if (val.clientManager) {
        this.$set(this.formData, 'clientManage', val.clientManager);
        this.$set(this.formData, 'clientManageId', val.clientManagerId);
      } else {
        this.$set(this.formData, 'clientManage', null);
        this.$set(this.formData, 'clientManageId', null);
      }
      this.clearValidate();
    },
    clearValidate() {
      this.$refs.xForm.clearValidate();
    },
    reset() {
      this.formData = {};
    },
    openContract() {
      this.isShowContract = true;
      this.$refs.agreementModel.init();
    },
    clearRelOrdersNum() {
      this.formData.relOrdersNum = null;
    },
    clearContractNum() {
      this.formData.relContractNum = null;
      this.formData.relContractId = null;
      this.formData.relContractType = null;
      this.formData.relContractCate = null;
    },
    chooseAgreement(row, type) {
      if (type) {
        if (type === 1) {
          this.formData.relContractNum = row.numb;
          this.formData.relContractCate = 2;
        } else {
          this.formData.relContractNum = row.contractNum;
          this.formData.relContractCate = 3;
        }
        this.formData.relContractId = row.id;
        if (row.dataType === 1) {
          this.formData.relContractType = 2;
        } else {
          this.formData.relContractType = 1;
        }
      } else {
        this.formData.relContractNum = row.numb;
        this.formData.relContractId = row.id;
        this.formData.relContractCate = 2;
      }
      this.isShowContract = false;
    },
    openChooseAccount() {
      this.isShowChooseAccount = true;
      this.$refs.chooseAccount.init();
    },
    chooseAccountEvent(account, type) {
      if (type === 1) {
        this.formData.sellerName = account.compName;
        this.formData.sellerId = account.id;
        this.formData.sellerUserType = 2;
      } else {
        this.formData.sellerName = account.realName;
        this.formData.sellerId = account.id;
        this.formData.sellerUserType = 1;
      }
      this.isShowChooseAccount = false;
      this.clearValidate();
    },
    async validEvent() {
      let errMap = await this.$refs.xForm.validate().catch((errMap) => errMap);
      return errMap ? false : true;
    },
    async submitEvent() {
      let sts = await this.validEvent();
      if (!sts) {
        return;
      }

      if (!this.formData.id) {
        this.createAttachedOrder();
      } else {
        this.updateAttachedOrder();
      }
    },
    async createAttachedOrder() {
      showLoading();
      let obj = Object.assign({}, this.formData);
      obj.files = obj.fileUuidList;
      let res = await $api.twoOrders.post("createAttachedOrder", obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("创建成功");
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async updateAttachedOrder() {
      showLoading();
      let obj = Object.assign({}, this.formData);
      obj.files = obj.fileUuidList;
      let res = await $api.twoOrders.post("updateAttachedOrder", obj);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    openOrderModal() {
      this.isShowChooseOrderTwo = true;
      this.$refs.refPaymentAboutOrderNew.init();
    },
    chooseOrderEventTwo(row) {
      this.$set(this.formData, 'relOrdersNum', row.ordersNum);
      this.$set(this.formData, 'clientManage', row.clientManager);
      this.$set(this.formData, 'clientManageId', row.clientManagerId);
      this.$set(this.formData, 'saleMan', row.saleMan);
      this.$set(this.formData, 'saleManId', row.saleManId);
      this.$set(this.formData, 'compName', row.compName);
      this.$set(this.formData, 'platformCompanyId', row.platformCompanyId);
      this.$set(this.formData, 'ordersTitleAttached', row.ordersTitle)
      this.isShowChooseOrderTwo = false;
      this.$refs.xForm.clearValidate();
    },
  }
}
</script>
<style scoped>
.input-border {
  border: 1px solid #dcdfe6;
  width: 300px;
  height: 34px;
  border-radius: 4px;
  padding: 0 .6em;
}

.input-border a, .input-border span {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  line-height: 34px;
}

.title {
  display: flex;
  align-items: center;
}

.block {
  width: 4px;
  height: 14px;
  background: #438DF3;
}

.title span {
  font-size: 15px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: bold;
  color: #438DF3;
  margin-left: 6px;
}

.footer-btn {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 98%;
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
}
</style>